import { render, staticRenderFns } from "./InputGroupAppend.vue?vue&type=template&id=3bdfccd5&"
import script from "./InputGroupAppend.vue?vue&type=script&lang=js&"
export * from "./InputGroupAppend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports